// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21cma","delete":"styles_delete__3l8oO","update":"styles_update__2qBRf","add":"styles_add__2Ms2k"};